var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPosition1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_807_38145)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.808 17.813C19.713 17.844 19.62 17.873 19.529 17.901C21.106 18.846 22 19.875 22 19.875C22 19.875 20.016 21.937 17.072 21.953C17.69 22.966 17.955 23.716 17.955 23.716C17.955 23.716 14.529 24.49 12 23.463C9.47099 24.49 6.04499 23.716 6.04499 23.716C6.04499 23.716 6.30999 22.966 6.92799 21.953C3.98499 21.937 1.99999 19.875 1.99999 19.875C1.99999 19.875 2.89399 18.846 4.47099 17.901C4.37999 17.873 4.28799 17.844 4.19199 17.813C1.80199 17.047 -1.42909e-05 14.286 -1.42909e-05 14.286C-1.42909e-05 14.286 1.17299 13.637 2.95999 13.307C2.95599 13.289 2.95299 13.271 2.94899 13.253C1.98099 13.096 0.915986 12.641 0.447986 11.468C-0.514014 9.06 0.370986 5.849 0.370986 5.849C0.370986 5.849 1.57799 6.301 2.85799 7.456C2.86199 7.428 2.86599 7.4 2.87099 7.372C2.23599 6.322 1.68499 4.886 2.30999 3.63C3.45999 1.314 6.49999 0 6.49999 0C6.49999 0 7.90399 3.908 5.81799 7.942C5.14799 12.406 6.55899 15.28 7.91299 16.934C9.14699 18.442 10.732 19.391 12 19.74C13.268 19.391 14.853 18.442 16.087 16.934C17.441 15.28 18.852 12.406 18.182 7.942C16.096 3.908 17.5 0 17.5 0C17.5 0 20.54 1.314 21.691 3.63C22.316 4.887 21.764 6.322 21.13 7.372C21.134 7.4 21.138 7.428 21.143 7.456C22.423 6.302 23.63 5.849 23.63 5.849C23.63 5.849 24.515 9.06 23.553 11.468C23.085 12.641 22.021 13.095 21.052 13.253C21.048 13.271 21.045 13.289 21.041 13.307C22.828 13.637 24.001 14.286 24.001 14.286C24.001 14.286 22.198 17.047 19.808 17.813ZM11 8.098V15H14V4.5L13.913 3H11.781L7.92699 6.953L10.074 9.047L11 8.098Z",
    fill: "url(#paint0_linear_807_38145)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_807_38145",
    x1: 25.5,
    y1: -0.125,
    x2: 4.5,
    y2: 23.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1C25A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#CFA20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#DDBD57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#CFA20E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DABC5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_807_38145"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition1);
export default __webpack_public_path__ + "static/media/Position-1.cd3d7b4286af85844344590236edc231.svg";
export { ForwardRef as ReactComponent };